(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfpl-quote-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  function bfplInitialize(scope){
  var root=(scope.id==='bfpl-quote-builder'?scope:scope.querySelector('#bfpl-quote-builder'));
  if(!root || root.dataset.bfplInitialized==='1')return;
  root.dataset.bfplInitialized='1';
  var form=root.querySelector('#BFPL-Quote-Builder');
  if(!form)return;
  function one(k){return form.querySelector('[data-qb="'+k+'"]:checked')||form.querySelector('[data-qb="'+k+'"]');}
  function val(k){var x=one(k);return x ? (x.value||'').trim():'';}
  function t(id,v){var e=root.querySelector('#'+id);if(e)e.textContent=v;}
  var blankSelect=form.querySelector('#bfpl-qb-blank');
  var processSelect=form.querySelector('#bfpl-qb-process');
  var blankGroups={
    'T-shirts':['Premium Next Level cotton tee','Standard everyday blank','Heavyweight / specialty','Help me choose'],
    'Hoodies':['Midweight fleece hoodie','Heavyweight hoodie','Help me choose'],
    'Hats':['Trucker cap','Unstructured dad cap','Flex-fit cap','Help me choose'],
    'Crewnecks':['Midweight fleece crewneck','Heavyweight fleece crewneck','Help me choose'],
    'Polos':['Performance polo','Cotton polo','Help me choose'],
    'Other / mixed':['Help me choose','I have a specific garment in mind']
  };
  function setGarmentDefaults(garment){
    if(blankSelect){
      blankSelect.replaceChildren();
      (blankGroups[garment]||blankGroups['Other / mixed']).forEach(function(x){var opt=document.createElement('option');opt.value=x;opt.textContent=x;blankSelect.appendChild(opt);});
    }
    if(garment==='Hats' && processSelect && processSelect.value==='Screen printing')processSelect.value='Embroidery';
  }
  var qtyInput=form.querySelector('[data-qb="quantity"]');
  var body=form.querySelector('#bfpl-qb-body');
  var datewrap=form.querySelector('#bfpl-qb-datewrap');
  var dateInput=form.querySelector('[data-qb="date"]');
  var price=root.querySelector('#bfpl-qb-price');
  var shopLink=root.querySelector('#bfpl-qb-shop-link');
  var configNode=root.querySelector('#bfpl-qb-pricing-config');
  var pricing={starter:{enabled:false,amount:null},rules:[]};
  try{if(configNode)pricing=JSON.parse(configNode.textContent);}catch(e){pricing={starter:{enabled:false,amount:null},rules:[]};}
  function validMoney(v){
    if(v===null || typeof v==='undefined' || String(v).trim()==='')return NaN;
    var n=Number(v);return Number.isFinite(n)&&n>0?n:NaN;
  }
  function formatMoney(n){return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:0,maximumFractionDigits:2}).format(n);}
  function clampQty(v){var n=parseInt(v,10);return Number.isFinite(n)?Math.max(1,Math.min(25000,n)):50;}
  function priceMatch(q,garment,proc,blank,location,ink,art,byDate,isStarter){
    // Do not give automated prices for other methods, artwork assistance or deadlines.
    if(proc!=='Screen printing'||art!=='Ready to send'||byDate)return null;
    if(isStarter && pricing.starter && pricing.starter.enabled===true){
      var starterAmount=validMoney(pricing.starter.amount);
      if(Number.isFinite(starterAmount))return {total:starterAmount,label:'Published 50-shirt package',source:'starter'};
    }
    var matches=(Array.isArray(pricing.rules)?pricing.rules:[]).filter(function(rule){
      var min=Number(rule.minimum),max=Number(rule.maximum);
      return rule.garment===garment && rule.blank===blank && rule.location===location && rule.ink===ink
        && Number.isInteger(min) && Number.isInteger(max) && min>=1 && max>=min && q>=min && q<=max
        && (rule.mode==='fixed'||rule.mode==='per_item') && Number.isFinite(validMoney(rule.amount))
        // Flat totals are only safe for a single exact quantity.
        && (rule.mode!=='fixed'||min===max);
    });
    if(!matches.length)return null;
    // If rates overlap, the tightest quantity bracket wins; otherwise editor order wins.
    matches.sort(function(a,b){return (Number(a.maximum)-Number(a.minimum))-(Number(b.maximum)-Number(b.minimum));});
    var r=matches[0],amount=validMoney(r.amount),setup=(r.setup===null||typeof r.setup==='undefined'||String(r.setup).trim()==='')?0:Number(r.setup);
    if(!Number.isFinite(setup)||setup<0)return null;
    var total=r.mode==='fixed'?amount:(q*amount+setup);
    if(!Number.isFinite(total)||total<=0)return null;
    return {total:Math.round(total*100)/100,label:r.label||'Configured standard-rate estimate',source:'rule',mode:r.mode,unit:amount,setup:setup};
  }
  function update(){
    var q=clampQty(val('quantity'));
    var garment=val('garment'), proc=val('process'), blank=val('blank'), location=val('location');
    var ink=val('ink'), art=val('art'), timing=val('timing'), date=val('date');
    var byDate=timing==='Needed by a date';
    if(datewrap)datewrap.classList.toggle('bfpl-qb__hide',!byDate);
    if(dateInput)dateInput.required=byDate;
    var isListedPackage=(garment==='T-shirts' && proc==='Screen printing' && blank==='Premium Next Level cotton tee' && q===50 && location==='Front only' && ink==='1' && art==='Ready to send' && !byDate);
    var quote=priceMatch(q,garment,proc,blank,location,ink,art,byDate,isListedPackage);
    var priced=Boolean(quote),amountShown=priced?formatMoney(quote.total):'Custom quote';
    var isDirectOrder=isListedPackage && priced && quote.source==='starter' && Math.abs(quote.total-500)<0.005;
    if(price){price.textContent=amountShown;price.classList.toggle('bfpl-qb__price--review',!priced);}
    t('bfpl-qb-mobile-price',priced?amountShown+' · Est.':'Custom review');
    t('bfpl-qb-price-caption',priced?(quote.source==='starter'?'Published package reference. Final specifications confirmed by BFPL.':'Preliminary estimate from BFPL’s standard-rate table. Final quote confirmed by the shop.'):'We’ll check the specifics and send an accurate price. No guesswork or invented totals.');
    t('bfpl-qb-status',priced?'Estimate only. Additional artwork work, special sizes, shipping, tax and scheduling may change the confirmed price.':'A person at BFPL will review print setup, garment costs and schedule before confirming your price.');
    if(shopLink)shopLink.classList.toggle('bfpl-qb__hide',!isDirectOrder);
    t('bfpl-qb-sum-garment',q.toLocaleString('en-US')+' '+garment);
    t('bfpl-qb-sum-process',proc);
    t('bfpl-qb-sum-blank',blank);
    t('bfpl-qb-sum-print',location+' · '+(ink==='Unsure'?'colors TBD':ink+(ink==='1'?' color':' colors')));
    t('bfpl-qb-sum-date',byDate?(date||'Date not selected'):'Flexible');
    form.querySelectorAll('[data-qb-preset]').forEach(function(btn){btn.setAttribute('aria-pressed',String(Number(btn.dataset.qbPreset)===q));});
    var lines=[
      'BFPL CUSTOM QUOTE REQUEST',
      'Garment: '+garment,
      'Garment preference: '+blank,
      'Decoration: '+proc,
      'Quantity: '+q,
      'Print location: '+location,
      'Print colors: '+ink,
      'Artwork: '+art,
      'Artwork link: '+(val('artlink')||'Will supply later'),
      'Timing: '+(byDate?('Needed by '+(date||'[DATE NOT PROVIDED]')):'Flexible / standard'),
      'Price shown to customer: '+(priced?(amountShown+' preliminary estimate ('+quote.label+'); subject to confirmation'):'Custom quote needed'),
      'Notes: '+(val('notes')||'None supplied'),
      'Please confirm final specifications, price, and production timing before any order.'
    ];
    if(body)body.value=lines.join('\n');
  }
  function quantitySet(v){qtyInput.value=clampQty(v);update();}
  form.querySelectorAll('[data-qb-qty]').forEach(function(b){b.addEventListener('click',function(){quantitySet(clampQty(qtyInput.value)+(b.dataset.qbQty==='plus'?1:-1));});});
  form.querySelectorAll('[data-qb-preset]').forEach(function(b){b.addEventListener('click',function(){quantitySet(b.dataset.qbPreset);});});
  form.addEventListener('change',function(e){
    if(e.target && e.target.matches('[data-qb="garment"]'))setGarmentDefaults(val('garment'));
    update();
  });
  form.addEventListener('input',update);
  if('IntersectionObserver' in window){
    var dock=root.querySelector('#bfpl-qb-mobile-dock');
    if(dock){var observer=new IntersectionObserver(function(entries){dock.style.visibility=entries[0].isIntersecting?'visible':'hidden';},{threshold:0});observer.observe(root);}
  }
  if(qtyInput)qtyInput.addEventListener('blur',function(){quantitySet(qtyInput.value);});
  form.addEventListener('submit',function(){
    if(qtyInput)qtyInput.value=clampQty(qtyInput.value);
    update();
  });
  update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){bfplInitialize(document);});
  else bfplInitialize(document);
  document.addEventListener('shopify:section:load',function(e){bfplInitialize(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
